/** Campos de endereço que a consulta de CEP pode preencher (e travar). */
export const CEP_ADDRESS_FIELDS = [
  'street',
  'neighborhood',
  'city',
  'state',
] as const;

export type CepAddressField = (typeof CEP_ADDRESS_FIELDS)[number];
export type CepAddressValues = Record<CepAddressField, string>;
export type CepLockedFields = Partial<Record<CepAddressField, boolean>>;

/**
 * O que gravar e o que travar depois de uma consulta de CEP.
 *
 * - Preenche os campos com o que a consulta devolveu. Com `onlyEmpty` (CEP
 *   vindo do CNPJ), só completa o que está vazio.
 * - TRAVA só quando o corretor digitou o CEP e a consulta trouxe o endereço
 *   COMPLETO (rua, bairro, cidade e UF). CEP de cidade (ex.: 84130-000, sem
 *   rua e bairro) e o preenchimento a partir do CNPJ não travam nada: antes
 *   cidade/UF ficavam travadas e o corretor precisava trocar o CEP para
 *   conseguir editar o endereço.
 */
export function resolveCepAddressFill(
  fetched: Partial<Record<CepAddressField, string | null | undefined>>,
  current: CepAddressValues,
  { onlyEmpty = false }: { onlyEmpty?: boolean } = {}
): { values: Partial<CepAddressValues>; locked: CepLockedFields } {
  const values: Partial<CepAddressValues> = {};
  for (const name of CEP_ADDRESS_FIELDS) {
    if (onlyEmpty && String(current[name] ?? '').trim()) continue;
    values[name] = String(fetched[name] ?? '').trim();
  }

  const isComplete = CEP_ADDRESS_FIELDS.every(
    name => !!String(fetched[name] ?? '').trim()
  );
  const locked: CepLockedFields = {};
  if (isComplete && !onlyEmpty) {
    for (const name of CEP_ADDRESS_FIELDS) locked[name] = true;
  }
  return { values, locked };
}
